import { MediaLibraryFileModel } from 'src/app/models/sales-funnel';
import { ContactItemType } from '../../models/contacts';

export class CreateContactDto {
  name: string;
  title?: string;
  bio?: string;
  email?: string;
  avatar?: string | number | number[];
  type: ContactItemType;

  constructor(
    data: {
      name: string;
      title?: string;
      bio?: string;
      email: string;
      avatar?: string | number | number[];
      type: ContactItemType;
    } = {
      name: '',
      title: '',
      bio: '',
      email: '',
      avatar: [],
      type: 'customer',
    },
  ) {
    Object.assign(this, data);
  }
}
